// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"HomePage_carouselWrapper__2jUAv","carouselChild":"HomePage_carouselChild__kfoaa"};